var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_109_3456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "url(#paint0_linear_109_3456)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.52658 9.89443C7.44178 8.62433 9.38571 7.787 10.3584 7.38244C13.1355 6.22735 13.7125 6.0267 14.0886 6.02007C14.1714 6.01861 14.3563 6.03911 14.4761 6.13633C14.5773 6.21842 14.6051 6.32931 14.6185 6.40715C14.6318 6.48498 14.6484 6.66227 14.6352 6.80081C14.4847 8.38205 13.8335 12.2193 13.5022 13.9903C13.3621 14.7397 13.086 14.9909 12.8188 15.0155C12.2381 15.069 11.7971 14.6317 11.2347 14.2631C10.3545 13.6861 9.85733 13.327 9.00301 12.764C8.0157 12.1134 8.65573 11.7558 9.2184 11.1714C9.36565 11.0184 11.9243 8.69112 11.9738 8.48C11.98 8.4536 11.9858 8.35518 11.9273 8.3032C11.8688 8.25123 11.7825 8.26901 11.7203 8.28314C11.632 8.30317 10.226 9.2325 7.5022 11.0711C7.10311 11.3452 6.74162 11.4787 6.41774 11.4717C6.06069 11.464 5.37386 11.2698 4.86328 11.1038C4.23703 10.9003 3.7393 10.7926 3.78264 10.4469C3.80521 10.2668 4.05319 10.0827 4.52658 9.89443Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_3456",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 19.8517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CA4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D83BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_109_3456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.c1370e8499a78307cec8802138da1028.svg";
export { ForwardRef as ReactComponent };